<template>
  <p>
    {{ toggled ? text : truncatedText }}
    <ButtonLink
      v-if="!shortText"
      :text="toggled ? lessText : moreText"
      @click="toggle"
    />
  </p>
</template>

<script>
import ButtonLink from 'client/components/Buttons/ButtonLink.vue';

export default {
  name: 'ReadMore',

  components: {
    ButtonLink,
  },

  props: {
    lessText: {
      default: 'Read less',
      type: String,
    },
    limit: {
      default: 100,
      type: Number,
    },
    moreText: {
      default: 'Read more',
      type: String,
    },
    text: {
      required: true,
      type: String,
    },
  },

  data: () => ({
    toggled: false,
  }),

  computed: {
    shortText() {
      return this.text.length < this.limit;
    },

    truncatedText() {
      let finalText = '';

      if (this.shortText) { finalText = this.text; }

      for (let i = this.limit; i > 0 && !finalText; i -= 1) {
        const currChar = this.text.charAt(i);
        const prevChar = this.text.charAt(i - 1);
        const prevCharNotPunc = [',', ';', '.'].some(char => char === prevChar);

        if (currChar === ' ' && !prevCharNotPunc) {
          finalText = `${this.text.substring(0, i)}...`;
        }
      }

      return finalText;
    },
  },

  methods: {
    toggle() {
      this.toggled = !this.toggled;
    },
  },
};
</script>
